(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rael-category-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rael-category-showcase]');

    const getStep = (viewport, track) => {
      const firstCard = track.querySelector('.rael-product-card, .rael-category-showcase__collection-card');
      const gap = parseFloat(getComputedStyle(track).gap || '0');

      if (!firstCard) {
        return viewport.clientWidth * 0.8;
      }

      const cardWidth = firstCard.getBoundingClientRect().width;

      if (window.matchMedia('(max-width: 699px)').matches) {
        return cardWidth + gap;
      }

      return Math.max(viewport.clientWidth * 0.72, (cardWidth + gap) * 2);
    };

    roots.forEach((root) => {
      if (root.dataset.raelCategoryInit === 'true') return;
      root.dataset.raelCategoryInit = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-category-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-category-panel]'));
      const railStates = new Map();

      const setupRail = (panel) => {
        const viewport = panel.querySelector('[data-category-viewport]');
        const track = panel.querySelector('[data-category-track]');
        const previousButton = panel.querySelector('[data-category-prev]');
        const nextButton = panel.querySelector('[data-category-next]');

        if (!viewport || !track) return null;

        const updateState = () => {
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
          const hasOverflow = maxScroll > 6;
          const scrollLeft = viewport.scrollLeft;

          panel.classList.toggle('rael-category-showcase__panel--static', !hasOverflow);

          if (previousButton) {
            previousButton.disabled = !hasOverflow || scrollLeft <= 6;
          }

          if (nextButton) {
            nextButton.disabled = !hasOverflow || scrollLeft >= maxScroll - 6;
          }
        };

        const scrollRail = (direction) => {
          viewport.scrollBy({
            left: getStep(viewport, track) * direction,
            behavior: 'smooth',
          });
        };

        previousButton?.addEventListener('click', () => scrollRail(-1));
        nextButton?.addEventListener('click', () => scrollRail(1));
        viewport.addEventListener('scroll', updateState, { passive: true });

        return { updateState };
      };

      panels.forEach((panel) => {
        const state = setupRail(panel);
        if (state) {
          railStates.set(panel.dataset.categoryPanel, state);
        }
      });

      const getActivePanelId = () => {
        const activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        if (activeTab) return activeTab.dataset.categoryTab;

        const activePanel = panels.find((panel) => !panel.hidden);
        if (activePanel) return activePanel.dataset.categoryPanel;

        return panels[0]?.dataset.categoryPanel || null;
      };

      const setActive = (panelId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.categoryTab === panelId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.categoryPanel === panelId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        const state = railStates.get(panelId);
        if (state) {
          requestAnimationFrame(() => state.updateState());
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setActive(tab.dataset.categoryTab);
        });
      });

      const updateActiveRail = () => {
        const panelId = getActivePanelId();
        if (!panelId) return;
        const state = railStates.get(panelId);
        state?.updateState();
      };

      const initialPanelId = getActivePanelId();
      if (initialPanelId) {
        setActive(initialPanelId);
      }

      window.addEventListener('resize', updateActiveRail);
      updateActiveRail();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rael-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.rael-product-rail');

    roots.forEach((root) => {
      if (root.dataset.raelRailInit === 'true') return;

      const viewport = root.querySelector('[data-rail-viewport]');
      const track = root.querySelector('[data-rail-track]');
      const previousButton = root.querySelector('[data-rail-prev]');
      const nextButton = root.querySelector('[data-rail-next]');

      if (!viewport || !track) return;

      root.dataset.raelRailInit = 'true';

      const getStep = () => {
        const firstCard = track.querySelector('.rael-product-card');
        const gap = parseFloat(getComputedStyle(track).gap || '0');

        if (!firstCard) {
          return viewport.clientWidth * 0.8;
        }

        const cardWidth = firstCard.getBoundingClientRect().width;

        if (window.matchMedia('(max-width: 699px)').matches) {
          return cardWidth + gap;
        }

        return Math.max(viewport.clientWidth * 0.72, (cardWidth + gap) * 2);
      };

      const updateState = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const hasOverflow = maxScroll > 6;
        const scrollLeft = viewport.scrollLeft;

        root.classList.toggle('rael-product-rail--static', !hasOverflow);

        if (previousButton) {
          previousButton.disabled = !hasOverflow || scrollLeft <= 6;
        }

        if (nextButton) {
          nextButton.disabled = !hasOverflow || scrollLeft >= maxScroll - 6;
        }
      };

      const scrollRail = (direction) => {
        viewport.scrollBy({
          left: getStep() * direction,
          behavior: 'smooth',
        });
      };

      previousButton?.addEventListener('click', () => scrollRail(-1));
      nextButton?.addEventListener('click', () => scrollRail(1));
      viewport.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);

      updateState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
